export const formatLocationObject = (location, type) => {
  if (!(type === 'ELASTIC_SEARCH' || type === 'GOOGLE_MAPS')) return null

  const latitude = location.latitude || location.lat
  const longitude = location.longitude || location.lng || location.lon

  if (type === 'ELASTIC_SEARCH') return { lat: latitude, lon: longitude }
  if (type === 'GOOGLE_MAPS') return { lat: latitude, lng: longitude }
}
